import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib//helpers/api';
import { types, actions } from './reducer';
import StatusTypeService from '@iso/services/SettingsService/OrderService/StatusTypeService';

function* deleteOrderStatusType({ id }) {
    try {
        yield call(StatusTypeService.deleteOne, id);
        yield put(actions.deleteOrderStatusTypeSucceeded(id));
    } catch (error) {
        yield put(actions.deleteOrderStatusTypeFailed(extractError(error)));
    }
}

function* watchDeleteOrderStatusType() {
    yield takeEvery(
        types.REQUEST_DELETE_ORDER_STATUS_TYPE,
        deleteOrderStatusType,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteOrderStatusType),
    ]);
}

export default deleteSaga;
